function isEnumValue(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean');
}
export function enumValues(enumObject) {
    return Object.values(enumObject).filter(isEnumValue);
}
export function enumLabelMap(enumObject) {
    return Object.fromEntries(enumObject.options.map((item) => [String(item.value), item.label]));
}
//# sourceMappingURL=utils.js.map